//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import PropertiesUtils from "../../mixins/properties-utils";

export default {
    name: "QfPContainers",
    mixins: [PropertiesUtils],
    data() {
        return {
            localValue: null,
            isNamespaced: false
        };
    },
    watch: {
        activeComponent: {
            handler(val) {
                this.localValue = this.properties[val].parent;
                this.isNamespaced = this.__isInNamespace(this.localValue);
            },
            immediate: true
        }
    },
    computed: {
        ...mapState("components", ["containers", "properties", "components", "bodyReference", "activeComponent"]),
        options() {
            const properties = this.properties[this.activeComponent];
            const config = this.components[properties.__component];
            let entries = [{ label: this.$t("userInterface.containerFilterDefault"), value: false }];

            if (properties.__component === "ctrl-slot") {
                const parentProperties = this.properties[this.localValue];
                const ignore = this.childrenList(this.activeComponent);
                entries = this.filterSlotContainers(parentProperties.__component, ignore);
            } else if (properties.__component === "ctrl-fragment") {
                entries = this.filterContainers({ noSegment: true });
            } else if (config.acceptNodes || config.slots) {
                const ignore = this.childrenList(this.activeComponent, true);
                entries = this.filterContainers({ ignore });
            } else {
                entries = this.filterContainers({});
            }

            return entries;
        }
    },
    methods: {
        ...mapMutations("components", ["addToParent"]),
        updateValue(value) {
            const properties = this.properties[this.activeComponent];
            if (value !== properties.parent) {
                const newNamespaceState = this.__isInNamespace(value);
                if (this.isNamespaced || newNamespaceState) {
                    this.isNamespaced = newNamespaceState;
                    this.__resetComponentModel(this.activeComponent, { get: true, set: true });
                }
                this.addToParent({ guid: this.activeComponent, to: value });
                this.$root.$emit("ui-render-interface");
            }
        },
        sort(item1, item2) {
            let sortValue = 0;
            const name1 = item1.label.toLowerCase();
            const name2 = item2.label.toLowerCase();

            if (name1 > name2) {
                sortValue = 1;
            } else if (name1 < name2) {
                sortValue = -1;
            }

            return sortValue;
        },
        childrenList(parent, self = false) {
            const children = [];
            if (self) {
                children.push(parent);
            }
            this.bodyReference[parent].forEach(component => {
                const properties = this.properties[component.guid];
                const config = this.components[properties.__component];
                if (config.acceptNodes || config.slots) {
                    children.push(component.guid);
                }
            });
            children.forEach(child => {
                children.push(...this.childrenList(child));
            });
            return children;
        },
        filterSlotContainers(containerType, ignore = [], parent = this.localValue) {
            const filtered = [];
            Object.entries(this.properties).forEach(([key, data]) => {
                const config = this.components[data.__component];
                if (!ignore.includes(key) && config.slots && (data.__component === containerType)) {
                    const entry = { label: data.label || data.__generics.code || key, value: key, icon: config.icon };
                    if (parent === key) {
                        entry.rightIcon = "mdi-check";
                        entry.rightColor = "primary";
                    }
                    filtered.push(entry);
                }
            });

            return filtered.sort(this.sort);
        },
        filterContainers({
            ignore = [], containerType = [], parent = this.localValue, noSegment = false
        }) {
            const filtered = [];

            if (containerType.length) {
                Object.entries(this.properties).forEach(([key, data]) => {
                    const config = this.components[data.__component];
                    if (!data.__fragment && !ignore.includes(key) && containerType.includes(data.__component) && config.acceptNodes) {
                        const entry = { label: data.label || data.__generics.code || key, value: key, icon: config.icon };
                        if (parent === key) {
                            entry.rightIcon = "mdi-check";
                            entry.rightColor = "primary";
                        }
                        filtered.push(entry);
                    }
                });
            } else {
                Object.entries(this.properties).forEach(([key, data]) => {
                    const config = this.components[data.__component];
                    let possibleEntry = true;

                    if (data.__fragment) {
                        possibleEntry = false;
                    }

                    if (possibleEntry && ignore.includes(key)) {
                        possibleEntry = false;
                    }

                    if (possibleEntry && noSegment) {
                        possibleEntry = !this.__isInNamespace(key);
                    }

                    if (possibleEntry && config.acceptNodes) {
                        const entry = { label: data.label || data.__generics.code || key, value: key, icon: config.icon };
                        if (parent === key) {
                            entry.rightIcon = "mdi-check";
                            entry.rightColor = "primary";
                        }

                        filtered.push(entry);
                    }
                });
            }

            filtered.sort(this.sort);
            if (parent) {
                filtered.unshift({ label: this.$t("userInterface.containerFilterDefault"), value: false, inset: true });
            } else {
                filtered.unshift({
                    label: this.$t("userInterface.containerFilterDefault"), value: false, inset: true, rightIcon: "mdi-check", rightColor: "primary"
                });
            }
            return filtered;
        }
    }
};
